import { render, staticRenderFns } from "./StickyTextElement.vue?vue&type=template&id=5f0f7fa6&scoped=true&"
import script from "./StickyTextElement.vue?vue&type=script&lang=js&"
export * from "./StickyTextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0f7fa6",
  null
  
)

export default component.exports